import { call, put } from 'redux-saga/effects';
import { toast } from 'react-toastify';

import ApiKPI from '../../Api/ApiKPI';
import ToastMsg from '../../Components/ToastMsg';
import { creators as KPIActions } from '../../Reducers/Reporting/KPI';

export function* getKPISummary({ payload }) {
  try {
    const response = yield call(ApiKPI.getSummary, payload.selectedYears);

    if (response.status === 200) {
      yield put(KPIActions.kpiSuccess({ summaryData: response.data }));
    } else {
      if (response.status !== 401) toast.error(ToastMsg,
        {
          data: {
            title: 'KPI Summary',
            text: response.message,
          },
        },
      );
      yield put(KPIActions.kpiFailure(response.message));
    }
  } catch (e) {
    yield put(KPIActions.kpiFailure(e));
  }
}
